import React, { useState, useEffect } from "react";
import { ChevronDown, Circle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Link } from "@/components/common/Link";
export default function TheFirstSip() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const [date, setDate] = useState("");
  useEffect(() => {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: "short",
      month: "short",
      day: "numeric"
    };
    setDate(now.toLocaleDateString("en-US", options));
  }, []);
  return <section data-section-id="46567" id="dont-just-travel-ps-travel" className="bg-zinc-900 text-foreground relative h-screen w-full overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/30 z-10" /> {}
        <video autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/medellin_naxos_poster.png" className="h-full w-full object-cover opacity-70">
          <source src="/videos/medellin_naxos_experience.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/medellin_naxos_poster.png" alt="Misty Medellin hills and Naxos waves" className="h-full w-full object-cover" />
        </video>
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 flex flex-col items-center justify-center h-full">
        <div ref={textRef} className={cn("transition-all duration-1000 ease-out transform flex flex-col items-center", textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <Link to="/" className="mb-8">
            
          </Link>
          <h1 className="font-serif font-light text-5xl md:text-7xl lg:text-8xl xl:text-9xl text-center leading-tight text-secondary drop-shadow-2xl tracking-tight">
            Don’t just travel, <br className="hidden md:block" />
            <span className="italic">PS Travel.</span>
          </h1>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 right-0 z-30 hidden md:block">
        
      </div>

      {}
      <div className="absolute bottom-20 left-0 right-0 z-30 md:hidden flex justify-center">
        <div className="bg-card/60 backdrop-blur-md border border-white/10 py-2 px-4 rounded-full flex items-center gap-3 shadow-lg mx-4">
           <span className="relative flex h-2 w-2 shrink-0">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
            </span>
            <span className="font-mono text-[10px] text-foreground/90 uppercase tracking-wider truncate">
              Exploring: {date} • Medellin
            </span>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex flex-col items-center gap-2 animate-pulse">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-secondary/60">
          Explore
        </span>
        <ChevronDown className="w-6 h-6 text-secondary/80 animate-bounce" />
      </div>
    </section>;
}